import { useField, useForm } from 'react-final-form'
import { TableOfContent, TableOfContentProps } from './TableOfContent'

export type TableOfContentFieldProps = Omit<TableOfContentProps, 'value' | 'onChange'> & {
  name: string
  className?: string
}

export function TableOfContentField({ name, ...props }: TableOfContentFieldProps) {
  const form = useForm()
  const { input, meta } = useField<string>(name)

  const handleChange = (value: string) => {
    form.change(name, value)
  }

  return <TableOfContent value={input.value ?? ''} onChange={handleChange} isTouched={meta.touched} {...props} />
}
